export type DocumentType = "coverLetter" | "formalBusiness" | "resignation" | "referenceRequest";
export type TemplateType = "classic" | "modern" | "corporate";
export type ToneType = "professional" | "formal" | "friendly" | "concise";

export interface DocumentFields {
  // Sender
  yourName: string;
  yourEmail: string;
  yourPhone: string;
  yourAddress: string;
  date: string;
  // Recipient
  recipientName: string;
  recipientTitle: string;
  companyName: string;
  companyAddress: string;
  // Cover letter specific
  jobTitle: string;
  yourBackground: string;
  whyThisRole: string;
  // Resignation specific
  noticePeriod: string;
  lastWorkingDay: string;
  reasonForLeaving: string;
  // Reference request specific
  referenceName: string;
  referenceRelationship: string;
  purposeOfReference: string;
  // Formal business specific
  letterPurpose: string;
  keyMessage: string;
  // Shared
  tone: ToneType;
}

export interface DocumentDraft {
  subject: string;
  body: string; // full letter body as plain text, paragraphs separated by \n\n
}

export const EMPTY_FIELDS: DocumentFields = {
  yourName: "",
  yourEmail: "",
  yourPhone: "",
  yourAddress: "",
  date: new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }),
  recipientName: "",
  recipientTitle: "",
  companyName: "",
  companyAddress: "",
  jobTitle: "",
  yourBackground: "",
  whyThisRole: "",
  noticePeriod: "",
  lastWorkingDay: "",
  reasonForLeaving: "",
  referenceName: "",
  referenceRelationship: "",
  purposeOfReference: "",
  letterPurpose: "",
  keyMessage: "",
  tone: "professional",
};

export const REQUIRED_FIELDS: Record<DocumentType, (keyof DocumentFields)[]> = {
  coverLetter: ["yourName", "yourEmail", "recipientName", "companyName", "jobTitle", "yourBackground", "whyThisRole"],
  formalBusiness: ["yourName", "yourEmail", "recipientName", "companyName", "letterPurpose", "keyMessage"],
  resignation: ["yourName", "yourEmail", "recipientName", "companyName", "noticePeriod", "lastWorkingDay"],
  referenceRequest: ["yourName", "yourEmail", "referenceName", "referenceRelationship", "purposeOfReference"],
};
